<template>
  <Transition name="modal">
    <div v-if="props.options.showModal" class="modal-mask">
      <div class="modal-container" :style="{ width: props.width }">
        <div class="modal-header">
          <button
            v-if="props.options.showClose"
            class="close-black"
            @click="emit('showModalMessages', { message: { show: false } })"
          >
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
            />
          </button>
          {{ props.options.titleModal }}
        </div>

        <div class="modal-body text-center">
          <slot name="body">{{ props.options.textBodyModal }}</slot>
        </div>

        <div class="modal-footer">
          <slot name="footer" v-if="props.options.textButtonModal">
            <button
              class="button"
              @click="
              props.options.routerName
                  ? redirect(props.options.routerName)
                  : props.options.functionOptions
                  ? emit(props.options.functionOptions.name, props.options.functionOptions.parameter)
                  : props.options.presente
                  ? redirectFernanda()
                  : emit('showModalMessages', { message: { show: false } })
              "
            >
              {{ props.options.textButtonModal }}
            </button>
          </slot>
        </div>
      </div>
    </div>
  </Transition>
</template>
<script setup lang="ts">
  import router from '../../router'
  import { localeStore } from '../../stores/locale'
  import { useRoute } from 'vue-router'

  const storeLocale = localeStore()
  const props = defineProps({
    options: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: '400px'
    }
  })
  const emit = defineEmits(['showModalMessages'])

  const route = useRoute()

  function redirectFernanda() {
    emit('showModalMessages', { message: { show: false } })
    router.push({
      name: 'ModelPage',
      params: {
        locale: storeLocale.locale,
        name: 'fernanda-campos-presente-exclusivo',
        complement: 'photo'
      }
    })
  }
  function redirect(name: string) {
    if (name == 'AssineOptionsPage') {
      router.push({
        name,
        params: {
          locale: storeLocale.locale ?? 'pt-br'
        },
        query: {
          acionador: String(route.name),
          redirectCredits: 'true'
        }
      })
    } else {
      router.push({
        name,
        params: {
          locale: storeLocale.locale ?? 'pt-br'
        },
        query: {
          acionador: String(route.name)
        }
      })
    }
  }
</script>


<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
  }

  .modal-container {
    max-width: 600px;
    margin: auto;
    padding: 50px 50px;
    background-color: #fff;
    border-radius: 0px;
    border: 2px solid #cccccc;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }

  .modal-header {
    display: block;
    text-align: center;
  }

  .modal-body {
    margin: 20px 0;
    padding: 30px 50px;
    color: #5b5858;
    font-family: 'Roboto-Medium';
    font-size: 21px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .modal-header {
    color: #444444;
    font-family: 'Roboto-Medium';
    font-size: 21px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .modal-footer {
    justify-content: center;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter-from {
    opacity: 0;
  }

  .modal-leave-to {
    opacity: 0;
  }

  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .close-black {
    position: absolute;
    right: -40px;
    top: -40px;
    z-index: 1;
  }
  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .modal-container {
      width: 90%;
    }

    .modal-body {
      margin: 20px 0;
      padding: 10px 0px;
    }
  }
</style>
